import { createClient } from '@supabase/supabase-js';
import type { NewDatabase } from './types';
import { showRealFunctionErrors } from './functionErrors';

// Los errores de las funciones de Supabase muestran su motivo real, no solo «non-2xx» (ver functionErrors.js)
showRealFunctionErrors();

// Cargar credenciales desde variables de entorno
const SUPABASE_NEW_URL = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_NEW_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Validar que las credenciales estén configuradas
if (!SUPABASE_NEW_URL || !SUPABASE_NEW_KEY) {
  console.error('⚠️ Error: Las credenciales de Supabase no están configuradas en el archivo .env');
  console.error('Por favor, crea un archivo .env en la raíz del proyecto con:');
  console.error('REACT_APP_SUPABASE_URL=tu-url-aqui');
  console.error('REACT_APP_SUPABASE_ANON_KEY=tu-key-aqui');
}

export const supabase = createClient<NewDatabase>(SUPABASE_NEW_URL, SUPABASE_NEW_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
});
